module.exports = __webpack_public_path__ + "static/media/conflict.a2cee06e.jpg";